import { render, staticRenderFns } from "./preview-of-modal.vue?vue&type=template&id=1bfb913c"
import script from "./preview-of-modal.vue?vue&type=script&lang=js"
export * from "./preview-of-modal.vue?vue&type=script&lang=js"
import style0 from "./preview-of-modal.vue?vue&type=style&index=0&id=1bfb913c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports